module.exports = __webpack_public_path__ + "static/media/Faqs.5d60d0eb.svg";